import { gsap } from '../vendor/gsap';
import { ScrollToPlugin } from '../vendor/gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const headerContainer = document.querySelector('.header-container');

const scrollToElement = (element, duration = 0.5, offset = 0) => {
    gsap.to(window, {
        duration,
        scrollTo: {
            y: element,
            offsetY: headerContainer.offsetHeight + offset,
        },
    });
};

export default scrollToElement;
